import { Box, Text } from '@stitch-fix/mode-react';
import styles from './styles.module.scss';
const PromoCard = () => {
  return <Box className={styles.container} p={{
    sm: 1,
    lg: 1.5
  }}>
      <Text setting="title-medium" color="blue-45" mb={0.5}>
        Fresh ideas included
      </Text>
      <Text setting="body-medium" color="blue-45">
        Along with your search, we picked some items that felt similar in style.
      </Text>
    </Box>;
};
export { PromoCard };